import {propertyDefinitionsClient} from 'common/report/queries/app-api/property-definitions-client';
import {PropertyDefinition} from 'common/util/definitions-types';

import {Store} from './store';

// we use a different store for event properties, which will be rendered by the dropdown properties.
// we do this beause of how the store value is structure differently from the event-property-definition store.
// and this allows us to fetch multiple sets of properties, based on the events passed in the params.
export const eventPropertiesDefinitionsStore = new Store<{[paramsKey: string]: PropertyDefinition[]}>({
  apiClient: propertyDefinitionsClient,
  defaultValue: {},
  name: `event-properties-definitions`,

  // in an app, different properties-menu instances can have different properties they need to show
  // based on the event names given to them. here we maintain a map of fetch params to property lists
  transform: {
    index: (response, {subscription}) => ({[Store.getKey(subscription.params, subscription.options)]: response}),
  },
});
